// import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

import { getSelectedPlan, selectAddOnsToShow, selectShoppingCartConfig } from '../../../queries/selectors/shoppingCart';
import { selectCurrentContentFichaPath } from '../../../queries/selectors/contents';
import { selectUserData } from '../../../queries/selectors/user';
import { selectCurrentPaymentMethod } from '../../../queries/selectors/payment';

import withAuthGuard from '../../withAuthGuard';
import withNoAvailableProducts from '../../withNoAvailableProducts';
import withNoMembershipPurchased from '../../withNoMembershipPurchased';

import { selectProductToUpgrade, selectLocation, selectClient } from '../../../global-selectors';
import AddOns from '../../../components/ProductSelectionPage/motorplay/addOns';
import { injectIntl } from 'react-intl';
import { addProduct, setAddOnsToShow } from '../../../queries/actions/shoppingCart';
import { selectCouponApply, selectProductTypeAddOn, selectSubscriptionList } from '../../../queries/selectors/bootstrap';
import { applyProductRules } from '../../../queries/actions/rules';
import { deleteCouponCode } from '../../../queries/actions';

const mapStateToProps = state => ({
  path: selectCurrentContentFichaPath(state),
  user: selectUserData(state),
  productToUpgradeId: selectProductToUpgrade(state),
  location: selectLocation(state),
  client: selectClient(state),
  paymentMethod: selectCurrentPaymentMethod(state),
  selectedPlan: getSelectedPlan(state),
  shoppingCart: selectShoppingCartConfig(state),
  addOnList: selectProductTypeAddOn(state),
  addOnsToShow: selectAddOnsToShow(state),
  couponApply: selectCouponApply(state),
  subscriptions: selectSubscriptionList(state),
});

const mapDispatchToProps = (
  (dispatch) => bindActionCreators({
    addProduct: payload => addProduct(payload),
    setAddOnsToShow: payload => setAddOnsToShow(payload),
    deleteCouponCode: () => deleteCouponCode(),
    applyProductRules: (payload) => applyProductRules(payload)
  }, dispatch)
)

export default compose(
  withAuthGuard({ toLoginURL: true }),
  injectIntl,
  withNoMembershipPurchased,
  connect(mapStateToProps, mapDispatchToProps),
  withNoAvailableProducts('addOn')
)(AddOns);
